import React from "react";
import { PASSWORD_HINT } from "../../helpers/passwordRules";

/** Compact instruction under create / reset password fields. */
const PasswordRequirementsHint = ({ style }) => (
  <p
    className="password-requirements-hint"
    style={{
      marginTop: "6px",
      marginBottom: "8px",
      fontSize: "12px",
      lineHeight: "1.45",
      color: "#5a6b7d",
      ...style,
    }}
  >
    {PASSWORD_HINT}
  </p>
);

export default PasswordRequirementsHint;
